import React, { useRef, useState } from "react"
import { Form, Formik } from "formik"

import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"
import InputsWithValidate from "Components/UI/Molecules/InputsWithValidate"
import { FormikAutocomplete } from "Components/UI/Atoms/CustomAutocomplete"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import { interfaces } from "service/interfaces"

const ExportClients = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false)
  const createDismissableSnackbar = useCustomSnackbar()
  const formSubmitRef = useRef(null)

  const handleSubmit = () => {
    formSubmitRef.current.click()
  }

  const onSubmit = async (values) => {
    const origen = values.origen
    const bloqueado = values.bloqueado
    setLoading(true)
    await interfaces.salesCobranzas
      .exportClients(origen, bloqueado)
      .then((res) => {
        window.location.assign(res.data)
        createDismissableSnackbar(res.data, {
          variant: "success",
        })
        onClose()
      })
      .catch(() => {
        createDismissableSnackbar("Algo salió mal!", {
          variant: "error",
        })
      })
    setLoading(false)
  }

  const ORIGEN = [
    { id: "ECO", label: "ECO" },
    { id: "OEM", label: "OEM" },
    { id: "DOS", label: "DOS" },
  ]
  const BLOQUEADO = [
    { label: "SI", value: "SI" },
    { label: "NO", value: "NO" },
  ]

  const fields = (setFieldValue) => [
    {
      class: "custom",
      component: (
        <FormikAutocomplete
          label="Origen"
          name="origen"
          options={ORIGEN}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue("origen", value.id)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      class: "custom",
      component: (
        <FormikAutocomplete
          label="Bloqueado"
          name="bloqueado"
          options={BLOQUEADO}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue("bloqueado", value.value)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },

  ]

  return (
    <DialogComponent
      open={open}
      handleclose={onClose}
      title="Descargar estado de cuentas corrientes"
      disableBackdropClick={true}
      handleclosedisabled={loading}
      disableChildHeight
      disableEscapeKeyDown
      widthLarge={"500px"}
      actions={
        <CancelConfirmButtons
          onClickSubmit={handleSubmit}
          onClickCancel={onClose}
          disabledCancel={loading}
          disabledSubmit={loading}
          isLoading={loading}
        />
      }
      children={
        <Formik
          initialValues={{
            origen: null,
            bloqueado: "",

          }}
          onSubmit={onSubmit}
          enableReinitialize
         // validationSchema={exportClientsValidation}
        >
          {({ setFieldValue }) => (
            <Form>
              <InputsWithValidate
                fields={fields(setFieldValue)}
                spacing={2}
                setFieldValue={setFieldValue}
              />
              <button
                style={{ display: "none" }}
                type="submit"
                ref={formSubmitRef}
              />
            </Form>
          )}
        </Formik>
      }
    />
  )
}

export default ExportClients
